module.exports = __webpack_public_path__ + "img/room21.250bb385.jpg";